export default __webpack_public_path__ + "static/media/img2.2385d373.jpg";